import { useFeliz_React__React_useIntersect_Static_13EC530 } from "./UseIntersect.fs.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/./Interop.fs.js";

export function useFeliz_React__React_useInView_Static_13EC530(root, rootMargin, threshold) {
    const patternInput = useFeliz_React__React_useIntersect_Static_13EC530(root, rootMargin, threshold);
    const entry = patternInput[1];
    const patternInput_1 = reactApi.useState("none");
    const setVisibility = patternInput_1[1];
    const dependencies = [entry];
    reactApi.useEffect(() => {
        if (entry != null) {
            const entry_1 = entry;
            const matchValue = entry_1.intersectionRatio;
            switch (matchValue) {
                case 0: {
                    setVisibility("none");
                    break;
                }
                case 1: {
                    setVisibility("full");
                    break;
                }
                default:
                    setVisibility("partial");
            }
        }
        else {
            setVisibility("none");
        }
    }, dependencies);
    return [patternInput[0], patternInput_1[0]];
}

